// Native option text must stay a text node: visual-edit instrumentation wraps
// JSX expressions in spans, which is invalid inside an HTML option.
import { createElement } from "react";
export default function TextOption({ value, label }) {
  return createElement("option", { value }, label);
}
